/* ==========================================================================
   VYLNS — theme behaviour
   Vanilla JS, no dependencies. Loaded with `defer`.
   Everything here re-initialises on Shopify theme editor events so sections
   keep working when merchants drag them around in the customizer.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD';

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: money
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* --- Scroll reveal ---------------------------------------------------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.v-rv:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* --- Mobile nav drawer ------------------------------------------------ */
  function initDrawer(root) {
    (root || document).querySelectorAll('[data-v-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = document.getElementById(btn.getAttribute('data-v-drawer-toggle'));
        if (!d) return;
        var open = d.classList.toggle('is-open');
        d.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });
  }

  /* --- Drop countdown ---------------------------------------------------
     Reads an ISO datetime from a data attribute set by the section schema.
     Hides itself once the drop has landed rather than showing 00:00:00:00. */
  function initClock(root) {
    (root || document).querySelectorAll('[data-v-clock]').forEach(function (el) {
      var target = new Date(el.getAttribute('data-v-clock')).getTime();
      if (isNaN(target)) { el.style.display = 'none'; return; }
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var ms = target - Date.now();
        if (ms <= 0) { el.setAttribute('data-v-ended', 'true'); ms = 0; }
        var s = Math.floor(ms / 1000);
        el.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
        el.querySelector('[data-h]').textContent = pad(Math.floor((s % 86400) / 3600));
        el.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
        el.querySelector('[data-s]').textContent = pad(s % 60);
      };
      tick();
      if (el._t) clearInterval(el._t);
      el._t = setInterval(tick, 1000);
    });
  }

  /* --- Quick add drawer (also the PDP sticky ATC pattern) ---------------
     Fetches the product JSON so size chips reflect real variant inventory
     rather than guessing from the card markup. */
  var qa = null;
  function getQA() { return qa || (qa = document.getElementById('v-quick-add')); }

  function openQuickAdd(handle) {
    var el = getQA();
    if (!el) return;
    fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { renderQuickAdd(p); })
      .catch(function () { window.location.href = window.Shopify.routes.root + 'products/' + handle; });
  }

  function renderQuickAdd(p) {
    var el = getQA();
    var img = el.querySelector('[data-qa-img]');
    if (p.featured_image) { img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2'); img.alt = p.title; }
    el.querySelector('[data-qa-name]').textContent = p.title;
    el.querySelector('[data-qa-price]').textContent = formatMoney(p.price);
    el.querySelector('[data-qa-link]').href = window.Shopify.routes.root + 'products/' + p.handle;

    var sizes = el.querySelector('[data-qa-sizes]');
    sizes.innerHTML = '';
    var first = null;
    p.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.className = 'v-chip' + (v.available ? '' : ' is-out');
      b.textContent = v.title;
      b.disabled = !v.available;
      b.dataset.vid = v.id;
      b.dataset.price = v.price;
      // Only clamp when Shopify actually tracks this variant. Untracked
      // inventory reports 0, which must not be read as "none left".
      if (v.inventory_management && typeof v.inventory_quantity === 'number' &&
          v.inventory_policy !== 'continue') {
        b.dataset.max = String(Math.max(1, v.inventory_quantity));
      }
      if (v.available && !first) { first = b; }
      b.addEventListener('click', function () { selectVariant(b); });
      sizes.appendChild(b);
    });
    if (first) selectVariant(first);
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
  }


  /* --- Quick-add quantity ------------------------------------------------
     The stepper clamps to real stock when Shopify tracks it, and the CTA
     shows the line total so the price reflects what will actually be
     charged rather than the unit price. ------------------------------- */
  function qtyInput() { var el = getQA(); return el && el.querySelector('[data-qa-qty-input]'); }

  function getQty() {
    var i = qtyInput();
    var n = i ? parseInt(i.value, 10) : 1;
    return (!n || n < 1) ? 1 : n;
  }

  function setQty(n) {
    var i = qtyInput();
    if (i) i.value = String(n);
  }

  function syncQty() {
    var el = getQA(); if (!el) return;
    var cta = el.querySelector('[data-qa-add]');
    var max = parseInt(cta.dataset.max, 10);
    var q = getQty();
    if (max && q > max) { q = max; setQty(q); }

    var down = el.querySelector('[data-qa-qty-down]');
    var up = el.querySelector('[data-qa-qty-up]');
    if (down) down.disabled = q <= 1;
    if (up) up.disabled = !!(max && q >= max);

    var unit = parseInt(cta.dataset.price, 10) || 0;
    cta.textContent = el.dataset.addLabel + ' — ' + formatMoney(unit * q);

    var cap = el.querySelector('[data-qa-cap]');
    if (cap) cap.textContent = (max && q >= max) ? ('Only ' + max + ' left') : '';
  }

  function bindQty(el) {
    var down = el.querySelector('[data-qa-qty-down]');
    var up = el.querySelector('[data-qa-qty-up]');
    var input = el.querySelector('[data-qa-qty-input]');
    if (down) down.addEventListener('click', function () { setQty(Math.max(1, getQty() - 1)); syncQty(); });
    if (up) up.addEventListener('click', function () { setQty(getQty() + 1); syncQty(); });
    if (input) {
      input.addEventListener('change', syncQty);
      input.addEventListener('input', syncQty);
    }
  }

  function selectVariant(btn) {
    var el = getQA();
    el.querySelectorAll('.v-chip').forEach(function (c) { c.classList.remove('is-on'); });
    btn.classList.add('is-on');
    var cta = el.querySelector('[data-qa-add]');
    cta.dataset.vid = btn.dataset.vid;
    cta.dataset.price = btn.dataset.price;
    cta.dataset.max = btn.dataset.max || '';
    cta.disabled = false;
    setQty(1);
    syncQty();
  }

  function closeQuickAdd() {
    var el = getQA();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
  }

  function initQuickAdd(root) {
    (root || document).querySelectorAll('[data-v-quick]').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openQuickAdd(btn.getAttribute('data-v-quick'));
      });
    });

    var el = getQA();
    if (!el || el._bound) return;
    el._bound = true;

    el.querySelector('[data-qa-close]').addEventListener('click', closeQuickAdd);
    bindQty(el);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuickAdd(); });

    el.querySelector('[data-qa-add]').addEventListener('click', function () {
      var cta = this;
      if (!cta.dataset.vid) return;
      cta.disabled = true;
      var label = cta.textContent;
      cta.textContent = 'Adding…';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(cta.dataset.vid, 10), quantity: getQty() }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          cta.textContent = 'Added';
          refreshCartCount();
          setTimeout(function () { closeQuickAdd(); cta.textContent = label; cta.disabled = false; }, 900);
        })
        .catch(function () { cta.textContent = label; cta.disabled = false; });
    });
  }

  /* --- Bundle: add all variants in a single cart call -------------------- */
  function initBundle(root) {
    (root || document).querySelectorAll('[data-v-bundle]').forEach(function (form) {
      if (form._bound) return;
      form._bound = true;

      var selects = form.querySelectorAll('[data-v-bundle-variant]');
      var total = form.querySelector('[data-v-bundle-total]');
      var compare = form.querySelector('[data-v-bundle-compare]');
      var saveEl = form.querySelector('[data-v-bundle-save]');
      var discount = parseFloat(form.dataset.vBundle) || 0;

      function recalc() {
        var sum = 0;
        selects.forEach(function (s) {
          var o = s.options[s.selectedIndex];
          if (o) sum += parseInt(o.dataset.price, 10) || 0;
        });
        var discounted = Math.round(sum * (1 - discount / 100));
        if (total) total.textContent = formatMoney(discounted);
        if (compare) compare.textContent = formatMoney(sum);
        if (saveEl) saveEl.textContent = 'Save ' + formatMoney(sum - discounted);
      }
      selects.forEach(function (s) { s.addEventListener('change', recalc); });
      recalc();

      form.querySelector('[data-v-bundle-add]').addEventListener('click', function () {
        var btn = this, label = btn.textContent;
        var items = [];
        selects.forEach(function (s) { items.push({ id: parseInt(s.value, 10), quantity: 1 }); });
        btn.disabled = true; btn.textContent = 'Adding…';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added to cart';
            refreshCartCount();
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1200);
          })
          .catch(function () { btn.textContent = label; btn.disabled = false; });
      });
    });
  }

  /* --- Cart count ------------------------------------------------------- */
  function refreshCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-v-cart-count]').forEach(function (n) {
          n.textContent = c.item_count;
        });
      });
  }

  /* --- Recently viewed --------------------------------------------------
     Stores handles in localStorage, then renders cards through the
     alternate product template (templates/product.card.liquid) so the markup
     stays in Liquid instead of being duplicated in JS. */
  var RV_KEY = 'vylns:recently-viewed';

  function trackRecentlyViewed() {
    var el = document.querySelector('[data-v-track-product]');
    if (!el) return;
    var handle = el.getAttribute('data-v-track-product');
    var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h !== handle; });
    list.unshift(handle);
    localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
  }

  function initRecentlyViewed(root) {
    var host = (root || document).querySelector('[data-v-recent]');
    if (!host) return;
    var current = host.getAttribute('data-v-recent-exclude') || '';
    var limit = parseInt(host.getAttribute('data-v-recent-limit'), 10) || 6;
    var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]')
      .filter(function (h) { return h && h !== current; })
      .slice(0, limit);

    if (!list.length) { host.closest('[data-v-recent-section]').style.display = 'none'; return; }

    Promise.all(list.map(function (h) {
      return fetch(window.Shopify.routes.root + 'products/' + h + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      host.innerHTML = parts.join('');
      initQuickAdd(host);
    });
  }

  /* --- PDP sticky add to cart ------------------------------------------
     Reveals the fixed bar once the inline ATC scrolls out of view. */
  function initStickyAtc() {
    var anchor = document.querySelector('[data-v-atc-anchor]');
    var bar = document.querySelector('[data-v-sticky-atc]');
    if (!anchor || !bar || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-open', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* --- Boot ------------------------------------------------------------- */
  function boot(root) {
    initReveal(root);
    initDrawer(root);
    initClock(root);
    initQuickAdd(root);
    initBundle(root);
    initRecentlyViewed(root);
    initStickyAtc();
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
    trackRecentlyViewed();
  });

  /* Theme editor lifecycle — sections re-render without a page reload. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-v-clock]').forEach(function (el) { if (el._t) clearInterval(el._t); });
  });
})();
